import env from '@/config'

export function bannerHtml(affiliateBanner) {
    return `
        <a href="https://www.piwi247.com/signup?referral_code=${affiliateBanner.referral_code}">
        <img src="${env.api.url}/banner/${affiliateBanner.banner}/download?size=${affiliateBanner.size}" alt="${affiliateBanner.campaign_name}">
        </a>
    `
}

export function bannerPreviewURL(affiliateBanner) {
    return `${env.api.url}/banner/${affiliateBanner.banner}/download?size=${affiliateBanner.size}`
}